import { useMediaQuery } from '@mui/material';
import React, { createContext, ReactNode, useState } from 'react';
import { useLocalStorage } from '../../hooks/providers/useLocalStorage';

type ThemeOptionType = {
  isDark: boolean;
};

type PropsThemeOptionContext = {
  state: ThemeOptionType;
  setState: React.Dispatch<React.SetStateAction<ThemeOptionType>>;
};

const DEFAULT_VALUE = {
  state: {
    isDark: false,
  },
  setState: () => {},
};

const ThemeOptionContext = createContext<PropsThemeOptionContext>(DEFAULT_VALUE);

const ThemeOptionProvider = ({ children }: { children: ReactNode }) => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const localStorage = useLocalStorage();
  let isDark = localStorage.getItem('isDark');

  if (isDark === null || isDark === undefined) {
    isDark = prefersDarkMode;
    localStorage.setItem('isDark', isDark);
  }
  const [state, setState] = useState({ isDark });

  return (
    <ThemeOptionContext.Provider
      value={{
        state,
        setState,
      }}
    >
      {children}
    </ThemeOptionContext.Provider>
  );
};

export { ThemeOptionProvider };
export default ThemeOptionContext;
